import { Outlet, createFileRoute } from "@tanstack/react-router";
import { Suspense } from "react";

import { FleetsProfileHeader } from "./-components/FleetsProfileHeader";

export const Route = createFileRoute("/_staff/fleets/$id/_layout")({
  component: Layout,
});

function Layout() {
  return (
    <>
      <FleetsProfileHeader />
      <Suspense>
        <Outlet />
      </Suspense>
    </>
  );
}
